import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

export const Hero = () => {
  const [terminalText, setTerminalText] = useState('');
  const fullText = 'cozmoz scan --target app.apk --mode aggressive';

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      if (i <= fullText.length) {
        setTerminalText(fullText.slice(0, i));
        i++;
      } else {
        clearInterval(interval);
      }
    }, 45);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="home" className="min-h-screen flex items-center justify-center pt-20 relative overflow-hidden">
      {/* Gradient orbs */}
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-[#00ffd5]/[0.03] rounded-full blur-[180px]"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-[#39ff14]/[0.02] rounded-full blur-[160px]"></div>

      {/* Grid overlay */}
      <div className="absolute inset-0 grid-bg"></div>

      {/* Horizontal scan lines */}
      <div className="absolute inset-0 opacity-[0.015]" style={{
        backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,255,213,0.1) 2px, rgba(0,255,213,0.1) 4px)',
        backgroundSize: '100% 4px'
      }}></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-5xl mx-auto fade-in-up">
          {/* Status badge */}
          <div className="flex items-center justify-center mb-12">
            <div className="tag">
              <span className="w-[6px] h-[6px] rounded-full bg-[#39ff14] shadow-[0_0_8px_#39ff14]"></span>
              Now Finding Vulnerabilities in Production
            </div>
          </div>

          {/* Main headline */}
          <div className="text-center md:text-left">
            <h1 className="text-5xl md:text-7xl lg:text-[5.5rem] font-extrabold text-white leading-[1.02] tracking-[-0.03em] mb-8">
              Your App Has
              <br />
              <span className="gradient-accent glow-text">Critical Flaws.</span>
              <br />
              <span className="text-white/30">Your Scanner Has No Idea.</span>
            </h1>

            <p className="text-lg md:text-xl text-white/40 max-w-2xl font-light leading-relaxed mb-12" style={{ fontFamily: 'var(--font-body)' }}>
              The first AI that actually thinks like a hacker. It doesn't match patterns.
              It reasons. It plans attacks. It breaks in. Then it proves it.
            </p>
          </div>

          {/* Terminal preview */}
          <div className="max-w-2xl mb-12">
            <div className="bg-[#0d0d12] border border-white/[0.06] rounded-sm overflow-hidden">
              <div className="flex items-center gap-2 px-4 py-2.5 border-b border-white/[0.04]">
                <div className="flex gap-1.5">
                  <div className="w-2.5 h-2.5 rounded-full bg-[#ff3333]/60"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-[#ffb800]/60"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-[#39ff14]/60"></div>
                </div>
                <span className="font-mono text-[0.65rem] text-white/40 ml-2">terminal</span>
              </div>
              <div className="p-5 font-mono text-sm">
                <div className="flex items-center gap-2">
                  <span className="text-[#00ffd5]">$</span>
                  <span className="text-white/70">{terminalText}</span>
                  <span className="text-[#00ffd5] animate-pulse">|</span>
                </div>
                <div className="mt-3 text-white/40 text-xs space-y-1">
                  <div>[<span className="text-[#39ff14]">+</span>] 47 screens mapped in 3 minutes</div>
                  <div>[<span className="text-[#39ff14]">+</span>] Authorization model: role-based, 3 user types</div>
                  <div>[<span className="text-[#ff3333]">!</span>] <span className="text-[#ff3333]">CRITICAL</span> User A can access User B's orders via /api/v2/orders/&#123;id&#125;</div>
                  <div>[<span className="text-[#ff3333]">!</span>] <span className="text-[#ffb800]">HIGH</span> Payment endpoint replays without token validation</div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-4 items-center md:items-start">
            <button
              className="btn-primary flex items-center gap-3"
              onClick={() => window.open('https://cal.com/mahima-arora-0f2025/30min?overlayCalendar=true', '_blank')}
            >
              See It Break Your App
              <ArrowRight className="w-4 h-4" />
            </button>
            <span className="font-mono text-[0.65rem] text-white/40 tracking-wider self-center">
              UPLOAD YOUR APK. GET RESULTS IN 30 MINUTES.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
